import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import {
  VISIBILITY_PRIVATE,
  VISIBILITY_PUBLIC
} from "@gettactic/api";
import { Switch } from "@gettactic/components/src/primitives/Switch";

/**
 * Toggles whether the reservation is private. When on, the schedule's
 * visibility is set to "private" so its details are hidden from other users;
 * when off it falls back to "public". The underlying API supports a third
 * "confidential" value which is intentionally not exposed here.
 */
export const ReserveFormVisibility: React.FC = () => {
  const { form } = useReserveForm();
  const visibility = form.watch("visibility");
  const isPrivate = visibility === VISIBILITY_PRIVATE;

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex flex-col">
        <span className="font-inter font-medium text-neutral-800 text-sm">
          Private reservation
        </span>
        <span className="font-inter text-neutral-700 text-xs">
          Hide the details of this reservation from other users
        </span>
      </div>
      <Switch
        size="sm"
        checked={isPrivate}
        onCheckedChange={(checked) =>
          form.setValue(
            "visibility",
            checked ? VISIBILITY_PRIVATE : VISIBILITY_PUBLIC
          )
        }
      />
    </div>
  );
};
